import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls, MeshDistortMaterial, BakeShadows } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame } from '@react-three/fiber';
import { useLoader } from '@react-three/fiber'
import { useTexture } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

import { EffectComposer, Vignette } from "@react-three/postprocessing";
import { BlendFunction } from 'postprocessing'
import { Reverse } from './Reverse'
import { MeshBasicMaterial } from 'three';



let holding = false;

function Background() {
  const {scene, camera} = useThree();
  let minus = 0;
  
  camera.position.set(0, 0, 22);
  camera.lookAt(new THREE.Vector3(0,0,0));
  camera.near = 20;
  camera.far = 50;
  camera.fov = 60;
  camera.updateProjectionMatrix();

  useFrame(({clock}) => {
    camera.position.z = -50 + clock.elapsedTime + minus;
    camera.lookAt(new THREE.Vector3(0,0,-61 + clock.elapsedTime + minus));
    if(clock.elapsedTime + minus > 50) minus -= 50;
  })

  return (<>
  {/* <mesh >
    <boxGeometry args={[100,30,40]} />
    <meshDepthMaterial side={THREE.DoubleSide}/>
  </mesh>
  
  <mesh position={[0, -10, -10]}>
    <boxGeometry args={[100,10,2]} />
    <meshDepthMaterial side={THREE.DoubleSide}/>
  </mesh> */}
  </>)
}


function Pipes({}) {
  const ref = useRef();
  const f = 0;
  let material = new THREE.MeshDepthMaterial({side: THREE.DoubleSide});
  
  useEffect(() => {
    
    for(let i=0; i < 200; i++) {
      let points = [];
      let startX = (Math.random()-0.5) * 20 + 20 * (i % 2 === 0 ? 1:-1);
      let startY = (Math.random()-0.5) * 30;
      for(let j=0; j < 50; j++) points.push(new THREE.Vector3((Math.random()-0.5) + startX, (Math.random()-0.5) + startY, -j));
      for(let j=0; j < 40; j++) points.push(points[j].clone().add(new THREE.Vector3(0,0,-50)));

      let path = new THREE.CatmullRomCurve3(points, false);
      let geometry = new THREE.TubeGeometry(path, 1000, Math.random() * 0.5 + 0.1, Math.floor((Math.random() * 8 + 2)));
      let mesh = new THREE.Mesh(geometry, material);
      ref.current.add(mesh);
    }

    for(let i=0; i < 50; i++) {
      let points = [];
      let startX = (Math.random()-0.5) * 20;
      let startY = (Math.random()-0.5) * 10 + 15 * (i % 2 === 0 ? 1:-1);
      for(let j=0; j < 50; j++) points.push(new THREE.Vector3((Math.random()-0.5) + startX, (Math.random()-0.5) + startY, -j));
      for(let j=0; j < 40; j++) points.push(points[j].clone().add(new THREE.Vector3(0,0,-50)));

      let path = new THREE.CatmullRomCurve3(points, false);
      let geometry = new THREE.TubeGeometry(path, 1000, Math.random() * 0.5 + 0.1, Math.floor((Math.random() * 8 + 2)));
      let mesh = new THREE.Mesh(geometry, material);
      ref.current.add(mesh);
    }
    
  }, [f]);


  return (
    <group ref={ref}>
    </group>
  )
}

function Drawing() {
  const ref = useRef();
  let points = [];
  const {scene, camera} = useThree();
  let material = new THREE.MeshDepthMaterial({side: THREE.DoubleSide});
  let plane = useRef();


  useFrame(({clock, camera, mouse, raycaster}) => {
    plane.current.position.set(0, 0, camera.position.z - 20);

    if(holding) {
      
      raycaster.setFromCamera(mouse, camera);

      const intersects = raycaster.intersectObjects([plane.current], true );
      if(intersects.length > 0)
      {
        if(points.length === 0)
          points.push(intersects[0].point);
        else if(intersects[0].point.x != points[points.length - 1].x && intersects[0].point.y != points[points.length - 1].y)
          points.push(intersects[0].point);
      }
    } else if(points.length !== 0){
      let path = new THREE.CatmullRomCurve3(points, false);
      let geometry = new THREE.TubeGeometry(path, points.length, 0.2, 8);
      let mesh = new THREE.Mesh(geometry, material);
      ref.current.add(mesh);
      points = [];
    }
  })

  return (
    <group ref={ref}>

      <mesh ref={plane} rotation={[0, 0 ,0]}>
        <planeGeometry args={[1000, 1000]} />
        <meshBasicMaterial color="black" visible={false}/>
      </mesh>
    </group>
  )
}

function App() {
  const [id, setId] = useState(0);
  const [characters, set] = useState([]);

  let tanks = [];

  let startX = -40;
  for(let i=0; i < 4; i++) {
    startX += Math.random() * 20 + 5;
    tanks.push(new THREE.Vector3( startX, 1, -10));
  }
  

  return (
    <div id="wrapper" onMouseDown={() => {holding = true}} onMouseUp={() => {holding=false}}>
    <Canvas >
      

      <pointLight position={[0,0,0]} intensity={1.0} color='white' />

      <Pipes />
      <Drawing />
      <Background />


      {/* <OrbitControls />  */}
      <Stats />
      
      
      <EffectComposer>
        <Reverse />
        <Vignette eskil={false} offset={0.5} darkness={0.6} />
      </EffectComposer>
    </Canvas>
  </div>
  );
}

export default App;
